import React, {useRef} from "react";
import {Link} from "react-router-dom";
import cx from "classnames";

import trans from "../../../../common/utils/trans";
import {LLTable, WithPopover} from "../../../../components";
import {formatNumber, isCombinedMatch} from "../../../../common/utils";
import urls from '../../../../configs/urls';


export const BetHistoryDetailsDesktop = (
    {
        bet,
        isSystemCoupon,
        language,
        currency,
        setModal
    }
) => {
    const detailsRef = useRef(null);

    const betHistoryDetailItemTableConfig = {
        desktopGridProps: {
            repaintChangesOnly: true,
            ref: detailsRef,
            paging: {
                enabled: true,
                pageSize: 100,
            },
            noDataText: 'BET_DETAILS_NO_DATA',
            onContentReady: (e) => {
                if (e.component.getDataSource()?.items()?.length) {
                    const match = e.component.getDataSource()?.items()[0];

                    if (match?.customOdds > 0) {
                        e.component.columnOption('odds', 'visible', false);
                        document
                            .querySelector('#bet-history-detail-table')
                            .classList.add('bet-history-detail-table--with-summary');
                    }

                    if (!bet.isBetHasLiveMatch) {
                        e.component.columnOption('currentScore', 'visible', false);
                        e.component.columnOption('currentStatus', 'visible', false);
                    }

                    if (match && isCombinedMatch(match.matchId)) {
                        e.component.columnOption('oddsType', 'visible', false);
                        e.component.columnOption('oddsTypeSelection', 'visible', false);
                    }
                }
            },
            onRowPrepared: (e) => {
                if (e.data?.status) {
                    e.rowElement.classList.add(
                        `table-row__bet-detail--${e.data?.status}`
                    );
                }

                if (e.data?.type === 'LiveMatch') {
                    if (e.component.columnOption('type', 'width') !== 130) {
                        e.component.columnOption('type', 'width', 130);
                    }
                }
            },
        },
        desktop: {
            id: 'bet-history-detail-table',
            noPagination: true,
            customTotal: (data) =>
                data.length && data[0]?.customOdds > 0
                    ? {
                          title: 'Odds',
                          calcCustom: data.length ? data[0]?.customOdds : 0,
                      }
                    : null,
            columns: [
                {
                    key: 'rowChars',
                    title: trans('Row'),
                    sortOrder: 'asc',
                    width: 50,
                    visible: false,
                },
                {
                    key: 'date',
                    title: trans('Date'),
                    format: 'dateTimeWithoutYear',
                    width: 110,
                    sortOrder: 'asc',
                },
                {
                    key: 'type',
                    title: trans('Type'),
                    width: 140,
                    render: (options) => (
                        <WithPopover
                            popoverClasses="ll-popover__text"
                            dropDownRole={true}
                            popoverContent={
                                <span>
                                    {trans(
                                        options.value === 'PreMatch'
                                            ? 'Pre Match'
                                            : options.value === 'LiveMatch'
                                            ? 'Live Match'
                                            : options.value === 'OutRight'
                                            ? 'MENU_OUTRIGHTS'
                                            : ''
                                    )}
                                </span>
                            }
                        >
                            <p>
                                {options.value === 'PreMatch' ||
                                options.value === 'Combined'
                                    ? 'PM'
                                    : options.value === 'LiveMatch'
                                    ? `LM ${options.row.data.timeInfo} ${
                                          options.row.data.score
                                              ? ' / ' + options.row.data.score
                                              : ''
                                      }`
                                    : options.value === 'OutRight'
                                    ? 'O'
                                    : ''}
                            </p>
                        </WithPopover>
                    ),
                },
                {
                    key: 'sportId',
                    width: 70,
                    title: trans('Sport'),
                    render: (options) => (
                        <WithPopover
                            popoverClasses="ll-popover__text"
                            dropDownRole={true}
                            popoverContent={<span>{options.row.data?.sportName}</span>}
                        >
                            <i
                                className={`sport_icon_font-${options.value}`}
                                style={{ justifyContent: 'center' }}
                            />
                        </WithPopover>
                    ),
                },
                {
                    key: 'name',
                    minWidth: 150,
                    title: trans('BET_DETAILS_EVENT'),
                    render: (options) =>
                        options?.data?.url ? (
                            <Link
                                to={options?.data?.url}
                                className="data-table__cell--link"
                            >
                                <span>{options?.data?.name}</span>
                            </Link>
                        ) : (
                            <span>{options?.data?.name}</span>
                        ),
                },
                {
                    key: 'currentScore',
                    title: trans('Score'),
                    width: 80,
                    render: (options) => (
                        <span className={options?.data?.className}>
                            {options?.data?.isLive ? (
                                <i
                                    title="Live Match"
                                    className="doruk-live-match-01 coupons__live-indicator"
                                />
                            ) : null}
                            {options?.data?.currentScore}
                        </span>
                    ),
                },
                {
                    key: 'currentStatus',
                    title: trans('Coupon Status'),
                    width: 70,
                    render: (options) => (
                        <span className={options?.data?.className}>
                            {options?.data?.currentStatus}
                        </span>
                    ),
                },
                { key: 'oddsType', title: trans('Option') },
                { key: 'oddsTypeSelection', title: trans('Selection') },
                { key: 'odds', title: trans('Odds'), width: 70, format: 'odds' },
                {
                    key: 'matchId',
                    title: trans('Result'),
                    width: 60,
                    render: (options) => (
                        <p className="data-table__cell--bet-result-link">
                            <a
                                href={`${urls.prematchStatistics}${language}/match/${options.data.id}`}
                                target="_blank"
                                className="match__stats"
                                rel="noopener noreferrer"
                            >
                                <i className="doruk-result" />
                            </a>
                        </p>
                    ),
                },
            ],
        },
    };

    if (isSystemCoupon) {
        betHistoryDetailItemTableConfig.desktop.columns[0] =
            {key: 'key', title: trans('Row'), sortOrder: 'asc', width: 50};
    }

    return (
        <div className="bet-history-detail">
            <LLTable
                data={isSystemCoupon ?
                    bet?.betDetailsUniqueMatches
                    :
                    bet?.betDetailsMatches
                }
                customConfig={betHistoryDetailItemTableConfig}
                name="bet-details"
            />
            <div className="bet-history-detail__info">
                {!bet?.betDetailsMatches[0].customOdds &&
                    bet?.betDetailsGroups.map(group => (
                        <p className="bet-history-detail__info-row" key={group.key}>
                            {isSystemCoupon &&
                                <span className="bet-history-detail__info-td">
                                    <span>{trans('Combination')}: </span>
                                    <span className={cx(
                                        'bet-history-detail__info-combination',
                                        group.status
                                    )}
                                    >{group.key}</span>
                                </span>
                            }
                            <span className="bet-history-detail__info-td">
                                {trans("Stake")}: {
                                    formatNumber(group.sortedMatches[0].stake, 2, language, currency)
                                }
                            </span>
                            <span className="bet-history-detail__info-td">
                                {trans("Payout")}: {
                                    formatNumber(group.sortedMatches[0].payout, 2, language, currency)
                                }
                            </span>
                        </p>
                    ))
                }
            </div>
        </div>
    );
};